import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import ThemeContext from 'src/components/system_wide/theme_context'
import * as actionType from 'src/lib/actions'

const NavLogo = () => {
  const configContext = useContext(ThemeContext)
  const { collapseMenu } = configContext.state
  const { dispatch } = configContext

  let toggleClass = ['mobile-menu']
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on']
  }

  return (
    <React.Fragment>
      <div className="navbar-brand header-logo">
        <Link to="#" className="b-brand">
          <div className="b-bg">
            <i className="feather icon-trending-up" />
          </div>
          <span className="b-title">Risiko IDEA</span>
        </Link>
        <Link
          to="#"
          className={toggleClass.join(' ')}
          id="mobile-collapse"
          onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}>
          <span />
        </Link>
      </div>
    </React.Fragment>
  )
}

export default NavLogo
